import type { SelectModel } from '@/components/forms/FormSelect.vue';

export function toSelectModel<T extends { id: string | number; name: string }>(
  items: T[],
): SelectModel[] {
  return items.map((item) => ({ id: item.id, name: item.name }));
}

/**
 * Minimal shape for a UI parameter that carries a type and default.
 * Extend to match your real UiPluginParam if you like (e.g. add `name`, `options`, etc.).
 */
export type ParamWithTypeDefault = {
  type: 'boolean' | 'number' | 'string' | 'text' | 'select';
  default?: unknown;
};

export function truncate(text: string, length = 20) {
  return text.length > length ? text.substring(0, length) + '...' : text;
}
